/*
  Papel e sessão vêm do ApplicationContext (GET /me), não de decodificar o
  JWT aqui — o token carrega uma cópia do staff feita no login e ficaria
  desatualizado por até um dia. Deste arquivo sobrou só o logout.
*/

export const removeToken = () => {
  localStorage.removeItem("token");
  window.location.href = "/login";
};
